module.exports = __webpack_public_path__ + "static/media/user.7f8036a6.svg";